import { render, staticRenderFns } from "./PackageDetailFormDialog.vue?vue&type=template&id=a4a549f0"
import script from "./PackageDetailFormDialog.vue?vue&type=script&lang=js"
export * from "./PackageDetailFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports